import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, useSort, pick, useFacets } from "@nosto/preact"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"
import { toggleButtonId } from "./Sidebar"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import SortDropdown from "./elements/SortDropdown"
import {transformSavingsAndOffersFacetData, transformCategoriesFacetData} from "../helpers"
import { useEffect } from "preact/hooks"

function ToggleMobileSidebarButton({ selectedFiltersCount, className, setOpenedFacetId }) {

    return (
        <label
            for={toggleButtonId}
            onClick={()=>setOpenedFacetId(null)}
            className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-text-align-center ns-align-items-center ${className} ns-font-4 ns-font-bold`}
        >
            <img src="https://d21m4dsqdd3b9h.cloudfront.net/bigcommerce-f4083/onsiteContent/17454898397220.9573000895728379" alt="Filter Icon" class="ns-filter-icon" aria-hidden="false"></img>
            <span>All Filters</span>
            {/* {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )} */}
        </label>
    )
}

export default function Toolbar({openedFacetId, setOpenedFacetId}) {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    // console.log('pageType', pageType);

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    const { facets: unfilteredFacets } = useFacets();

    const body = document.querySelector("body");
    const actualPageType = body?.getAttribute("data-page-type")?.toLowerCase() || "";
    const isBrandPage = actualPageType.includes("brand");

    const facets = unfilteredFacets.filter(facet => !isBrandPage || facet.name !== "Brand");

    // console.log(facets);
    

    return (
        <div
        // ns-pr-2 ns-pb-1 ns-pl-2
            class={`ns-header-controls ns-d-flex ns-flex-column ns-flex-md-row ns-d-none ns-d-md-flex ns-flex-wrap align-center ns-justify-content-between ns-p-4 ns-ml-2 ns-mr-2`}
        >
            {/* {!loading && (
                <span
                    class="ns-d-inline ns-text-align-center ns-order-3 ns-d-md-block ns-order-md-first ns-align-self-md-center ns-color-black"
                    data-nosto-element="totalResults"
                >
                    {totalSummary}
                </span>
            )} */}
            {/* ns-justify-content-around */}
            <div class="ns-d-flex ns-align-items-center ns-w-100">
                <ToggleMobileSidebarButton
                    selectedFiltersCount={selectedFiltersCount}
                    setOpenedFacetId={setOpenedFacetId}
                />
                {/* <Select
                    value={activeSort}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu"
                    options={options}
                    label={"Sort by"}
                /> */}
                <SortDropdown openedFacetId={openedFacetId} setOpenedFacetId={setOpenedFacetId} isInToolbar={true} />
                <ul class="ns-list-unstyled ns-p-0 ns-m-0 ns-d-none ns-d-l-flex ns-toolbar-facets">
                
                    {facets?.slice(0,5)?.map(facet => {
                        switch (facet.type) {
                            case "terms":
                                if (facet.name === 'Savings & Offers') {
                                    // Transform the facet data before passing it to the Facet component
                                    const transformedData = transformSavingsAndOffersFacetData(facet?.data);
                                    // console.log('transformedData', transformedData);
                                    if(transformedData.length > 0){
                                        return <Facet key={facet.name} facet={{ ...facet, data: transformedData }} isInToolbar={true} openedFacetId={openedFacetId} setOpenedFacetId={setOpenedFacetId} />;
                                    } else {
                                        return null;
                                    }    
                                } else if (facet.name === 'Category') {
                                    const transformedCategoryData = transformCategoriesFacetData(facet?.data);
                                    // console.log(tr)
                                    if(transformedCategoryData.length > 0){
                                        return <Facet key={facet.name} facet={{ ...facet, data: transformedCategoryData }} isInToolbar={true} openedFacetId={openedFacetId} setOpenedFacetId={setOpenedFacetId} />;
                                    } else {
                                        return null;
                                    }
                                } else {
                                    // If the facet name does not match, return the Facet component without transforming the data
                                    return <Facet key={facet.name} facet={facet} isInToolbar={true} openedFacetId={openedFacetId} setOpenedFacetId={setOpenedFacetId} />;
                                }
                            case "stats":
                                return <RangeFacet key={facet.name} facet={facet} isInToolbar={true} openedFacetId={openedFacetId} setOpenedFacetId={setOpenedFacetId}/>
                            default:
                                return null
                        }
                    })}
                </ul>
            </div>
        </div>
    )
}
